import axios from 'axios';

export default {
    fileDownload,
    fileUpload,
};

// ファイルのダウンロードを行う。
async function fileDownload(DldStatus, DldS3Url, shareFileDldNm) {
    switch (DldStatus) {
        case '1':
            return 'continue';
        case '2': {
            // ダウンロードするファイル名。
            let fileName = '';
            // ダウンロードするファイル名を継承したか判定。
            if (shareFileDldNm === undefined || shareFileDldNm === null || shareFileDldNm === '') {
                // ダウンロードするファイル名を継承できなかった場合は、URLからファイル名相当の文字列を加工して抽出する。
                fileName = DldS3Url.split('?')[0].split('/').pop();
            } else {
                // ファイル名を引数から継承。
                fileName = shareFileDldNm;
            }
            // APIから取得したURL座標にアクセスする。
            const response = await fetch(DldS3Url);
            // アクセスしたURLのデータをblobとして変換する。
            const blob = await response.blob();
            // 明示的にblob要素として宣言する。
            const newBlob = new Blob([blob]);
            // blob要素をブラウザに生成して具現化する。
            const objUrl = window.URL.createObjectURL(newBlob);
            // 疑似的なaタグを発行する。
            const link = document.createElement('a');
            // blob要素をaタグに代入し、Javascriptエレメントに対してクリックイベントを発動する。
            link.href = objUrl;
            link.download = fileName;
            // ファイルをダウンロードする。
            link.click();
            // クリックイベント終了後を見越したタイマー処理。
            setTimeout(() => {
                // ブラウザのメモリを解放。
                window.URL.revokeObjectURL(objUrl);
            }, 250);
            return 'startDownload';
        }
        case '3':
            return 'endDownload';
        case '5':
        case '6':
            return 'error';
        default:
            return 'break';
    }
}

// S3にファイルをアップロードする。
async function fileUpload(url, formData) {
    // リクエストヘッダーを作成する。
    const requestHeader = {
        'Content-Type': formData.type,
    };

    return new Promise((resolve, reject) => {
        axios
            .put(url, formData, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}
